<template>
  <b-overlay :show="pageLoading" rounded spinner-variant="primary" class="view-user-details-overlay">
    <div v-if="user" class="view-user-details modal-font-family mt-2">
    <b-modal
      header-bg-variant="info"
      header-text-variant="light"
      ref='transferFilesBetweenUsers'
      id='transferFilesBetweenUsers'
      size='lg'
      scrollable
      hide-footer
      title='Transferir os arquivos entre usuários'
    >
      <section class='modal-font-family' >
        <modal-confirm-action
          variant='danger'
          refModal='transferFiles'
          idModal='transferFiles'
          :loading='loading'
          :description='descriptionTransferFiles'
          :title='titleTransferFiles'
          @confirmed='transferFilesBetweenUsers'
        />

        <div class="  w-100" :style="`min-height: ${users.length > 0 && !userIdToReceive? '340px' : ''}`" >
          <div class="d-flex w-100"  >
            <vue-bootstrap-typeahead
              class="w-100"
              v-model="userSelect"
              :maxMatches="maxMatchesSelect"
              :serializer="(item) => item.username"
              :data="users"
              sort-variant="length"
              @hit="selectByUser($event)"
              @input="clear"
              placeholder="Digite o e-mail do usuário para pesquisar"
              ref="userBaseAutocomplete"
            />
            <b-spinner v-if='loading' class='loading px-2 ml-2' variant="primary" label="Spinning"></b-spinner>
          </div>


          <div class='mt-3'>
            <p v-if='user && user.username'>Usuário que vai transferir os arquivos/informações: <strong>{{user.username}}</strong></p>

            <p v-if='userToReceive && userToReceive.username'>Usuário que vai receber os arquivos/informações: <strong>{{userToReceive.username}}</strong></p>
          </div>
        </div>

        <div class='mt-4 d-flex' >
          <b-button class="w-50 mr-2" variant="danger" @click='closeModalTransferFilesBetweenUsers()'>Cancelar</b-button>
          <b-button :disabled='!userIdToReceive' class="w-50" variant="success" @click='showTransferFilesBetweenUsers()'>Transferir</b-button>
        </div>
      </section>
    </b-modal>

    <b-modal
      size="lg"
      id="selectDateExemptionAuthentication"
      header-bg-variant="info"
      header-text-variant="light"
      title="Liberar autenticação em dois fatores."
      ref="selectDateExemptionAuthentication"
      hide-footer
      scrollable
    >
      <div class='modal_font_size'>
        <div class='w-100 mb-3'>
          <base-input-text
            class='w-100'
            :min='currentDate'
            v-model="twoFactorAuthenticationReleaseDeadline"
            label="Não solicitar autenticação em dois fatores até qual data?"
            type="date"
            block
          />
        </div>

        <b-input-group class='d-flex w-100'>
          <b-button
            @click="closeModalSelectDateExemptionAuthentication()"
            class='w-50' variant='danger'
            block
          >
            Cancelar
          </b-button>

          <b-overlay
            :show='loading'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='w-50 justify-content-center'
          >
            <b-button :disabled='!twoFactorAuthenticationReleaseDeadline' class='btn_save' @click='saveDateExemptionAuthentication' block>
              Salvar
            </b-button>
          </b-overlay>
        </b-input-group>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      id="selectExtraAccessDate"
      header-bg-variant="info"
      header-text-variant="light"
      title="Liberar dias acesso extra"
      ref="selectExtraAccessDate"
      hide-footer
      scrollable
    >
      <div class='modal_font_size'>
        <div class='w-100 mb-3' v-if='currentDate'>
          <base-input-text
            class='w-100'
            v-model="quantityDaysExtraAccess"
            label="Liberar quantos dias de acesso extra?"
            placeholder="Digite a quantidade de dias de acesso extra"
            type="nunber"
            v-mask="['#########']"
            block
          />
        </div>

        <b-input-group class='d-flex w-100'>
          <b-button
            @click="closeModalSetSelectExtraAccessDate()"
            class='w-50' variant='danger'
            block
          >
            Cancelar
          </b-button>

          <b-overlay
            :show='loading'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='w-50 justify-content-center'
          >
            <b-button :disabled='quantityDaysExtraAccess < 0' class='btn_save' @click='saveQuantityDaysExtraAccess()' block>
              Salvar
            </b-button>
          </b-overlay>
        </b-input-group>
      </div>
    </b-modal>

    <b-modal
      id="changePhone"
      size="lg"
      header-bg-variant="info"
      header-text-variant="light"
      title="Atualizar telefone"
      ref="changePhone"
      hide-footer
      scrollable
    >
      <change-phone
        :username='confirmationEmail'
        :phone='phone'
        @new-phone="closeModalChangePhone"
      />
    </b-modal>

    <modal-confirm-action
      refModal="modalConfirmBlockUser"
      idModal="modalConfirmBlockUser"
      title="Confirmar ação"
      :loading="loading"
      :description="`Confirmar ${dialogBlock.block ? 'desbloqueio' : 'bloqueio'} do usuário ${dialogBlock.email}?`"
      @confirmed="handleBlockAndUnblockUser"
    />

    <modal-confirm-action
      refModal="modalConfirmReleaseTrial"
      idModal="modalConfirmReleaseTrial"
      title="Confirmar ação"
      :loading="loading"
      description="Você está prestes a ativar o período de testes do HO Fácil Web para este usuário. Ao clicar no botão de confirmar o usuário terá acesso completo à plataforma durante os próximos 7 dias contados a partir da sua confirmação."
      @confirmed="handleReleaseTrialPlan"
    />

    <modal-copy-plan
      description="Você está prestes a ativar o período de testes do HO Fácil Web para este usuário. Ao clicar no botão de confirmar o usuário terá acesso completo à plataforma durante os próximos 7 dias contados a partir da sua confirmação."
      :is-open="openModal"
      :addedCopyPlan="addedCopyPlan"
      @submit="handleReleaseCopyPlan"
      @close="openModal = false"
    />

    <section-profile
      :user="user"
      ref='sectionProfile'
    />

    <b-modal
      id="modalChangeCPF"
      size="lg"
      header-bg-variant="info"
      header-text-variant="light"
      title="Atualizar CPF"
      ref="modalChangeCPF"
      hide-footer
      scrollable
    >
      <modal-change-c-p-f
        :cpf='cpfUpdate'
        :userId='userIdcpfUpdate'
        @close="closeModalCpfUpdate"
      />
    </b-modal>

    <modal-confirm-action
      refModal="modalConfirmDeleteAccount"
      idModal="modalConfirmDeleteAccount"
      title="Confirmar ação"
      :loading="loading"
      :description="`Você realmente deseja excluir a conta: ${modalDeleteAccount.user.username}?`"
      @confirmed="deleteAccount"
    />

    <b-modal
      size="lg"
      id="changeUserProfile"
      header-bg-variant="info"
      header-text-variant="light"
      title="Alterar o perfil do usuário"
      ref="changeUserProfile"
      hide-footer
      scrollable
    >
      <div class='modal_font_size'>
        <div class='w-100 mb-3' v-if='userProfile && userProfile.role'>
          <base-input-select
            class='w-100'
            v-model="userProfile.role"
            label="Selecione o perfil do usuário"
            placeholder="Selecione o perfil"
            _key="key"
            _value="value"
            :options="roles"
            block
          />
        </div>

        <b-input-group class='d-flex w-100'>
          <b-button
            @click="closeModalChangeUserProfile()"
            class='w-50' variant='danger'
            block
          >
            Cancelar
          </b-button>

          <b-overlay
            :show='loading'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='w-50 justify-content-center'
          >
            <b-button
              :disabled='!userProfile || !userProfile.role'
              class='btn_save'
              @click='changeUserProfile()'
              block
            >
              Salvar
            </b-button>
          </b-overlay>
        </b-input-group>
      </div>
    </b-modal>

    <section-actions
      v-if='!readOnly'
      :user="user"
      @trial-plan="$bvModal.show('modalConfirmReleaseTrial')"
      @release-plan="openModal = true"
      @block-user="(data) => showModalBlockUser(data)"
      @change-phone="(data) => setDataChangePhone(data)"
      @change-cpf="(data) => setDataChangeCPF(data)"
      @delete-account="(data) => setDeleteAccountd(data)"
      @select-date-exemption-authentication="(data) => setSelectDateExemptionAuthentication(data)"
      @select-extra-access-date="(data) => setSelectExtraAccessDate(data)"
      @transfer-files-between-users="(data) => showModalTransferFilesBetweenUsers(data)"
      @change-user-profile="(data) => showModalChangeUserProfile(data)"
    />

    <table-plans
      :user="user"
      :plans="userPlans"
      :plans-meta="userPlansMeta"
      :readOnly='readOnly'
      @change-plans="changePlans"
    />
    </div>
  </b-overlay>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import ChangePhone from '@/views/Access/ChangePhone'
import ModalChangeCPF from '@/components/Users/ModalChangeCPF'
import { mask } from 'vue-the-mask'
import ModalCopyPlan from '@/components/UserDetails/ModalCopyPlan.vue'
import SectionActions from '@/components/UserDetails/Actions.vue';
import SectionProfile from '@/components/UserDetails/Profile.vue';
import TablePlans from '@/components/UserDetails/Plans.vue';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import _ from 'underscore'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import BaseInputSelect from '../components/Base/BaseInputSelect.vue'
export default {
  name: 'UserDetails',
  components: { BaseInputSelect, ModalConfirmAction, VueBootstrapTypeahead, ModalCopyPlan, SectionActions, SectionProfile, TablePlans, ChangePhone, ModalChangeCPF },
  directives: { mask },
  data(){
    return {
      modalDeleteAccount: {
        open: false,
        user: {
          _id: '',
          username: '',
        }
      },
      confirmationEmail: '',
      userSelect: '',
      userToReceive: '',
      userIdTransfer: null,
      userIdToReceive: null,
      maxMatchesSelect: 100,
      users: [],
      disabled: false,
      descriptionTransferFiles: '',
      titleTransferFiles: '',
      twoFactorAuthenticationReleaseDeadline: null,
      twoFactorAuthenticationReleaseDeadlineUserId: null,
      quantityDaysExtraAccess: null,
      quantityDaysExtraAccessUserId: null,
      planId: null,
      phone: '',
      cpfUpdate: '',
      userIdcpfUpdate: '',
      userId: '',
      addedCopyPlan: false,
      dialogBlock: {},
      loading: false,
      pageLoading: true,
      openModal: false,
      userProfile: Object,
      roles: [
        { key: "admin" , value: "Administrador" },
        { key: "user" , value: "Usuário Comum" },
      ],
      messages: {
        'User does not exist': 'Usuário não existe',
        'User has already used free trial': 'Usuário já utilizou do plano gratuito',
        'Trial plan successfully activated': 'Plano gratuito ativado com sucesso',
        'Trial successfully activated': 'Plano ativado com sucesso',
        'User without plan': 'Usuário não tem plano',
        'Error updating user': 'Erro ao bloquear/desbloquear usuário',
        'User updated successfully': 'Usuário bloqueado/desbloqueado com sucesso'
      }
    }
  },
  async created(){
    try {
      this.userId = this.$route.params._id;
      if(this.userId){
        await this.handleGetUser(this.userId);
        await this.handleGetUserPlans({
          userId: this.userId,
          sortBy: 'createdAt',
          sortIn: 'desc'
        });
      }
      const breadcrumb = {
        page: 'Usuários',
        subPage: {
          name: 'Usuários',
          active: false
        },
        tabs: [
          {
            name: 'Dados pessoais',
            active: true
          }
        ]
      }
      this.setBreadcrumb(breadcrumb)
    } finally {
      this.pageLoading = false
    }
  },
  computed: {
    currentDate() {
      const user = this.$store.getters['user/current']
      return moment(user.currentDate).format('YYYY-MM-DD')
    },
    currentUser() {
      return this.$store.getters['user/current']
    },
    readOnly(){
      return !!this.currentUser.functionalities.find((x) => x.name === 'Gerenciar usuário (somente leitura)')
    },
    ...mapGetters('user', {
      user: 'getUser',
    }),
    ...mapGetters('userPlans', {
      userPlans: 'userPlans',
      userPlansMeta: 'userPlansMeta',
    }),
  },
  methods: {
    ...mapActions('user', {
      handleGetUser: 'handleGetUser',
      handleUserById: 'handleUserById',
      handleUserProfileById: 'handleUserProfileById',
      handleUnblockUser: 'handleUnblockUser',
      handleBlockUser: 'handleBlockUser',
      handleDeleteAccount: 'handleDeleteAccount',
      handTwoFactorAuthenticationReleaseDeadline: 'handTwoFactorAuthenticationReleaseDeadline',
      handleSetQuantityDaysExtraAccess: 'handleSetQuantityDaysExtraAccess',
      handleTransferFilesBetweenUsers: 'handleTransferFilesBetweenUsers',
      handleChangeProfile: 'handleChangeProfile',
    }),
    ...mapActions('userPlans', {
      handleGetUserPlans: 'handleGetUserPlans',
      handleAdminReleaseTrialPlan: 'handleAdminReleaseTrialPlan',
      handleAdminReleaseCopyPlan: 'handleAdminReleaseCopyPlan'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),

    async reloadUserData(){
      try {
        this.pageLoading = true
        await this.handleGetUser(this.userId)
        await this.handleGetUserPlans({ userId: this.userId })
      } finally {
        this.pageLoading = false
      }
    },

    async changePlans(page){
      const params = {
        ...this.userPlansMeta,
        userId: this.userId,
        skip: (page - 1) * this.userPlansMeta.limit,
        sortBy: 'createdAt',
        sortIn: 'desc'
      }

      await this.handleGetUserPlans(params);
    },

    async handleReleaseTrialPlan(){
      const response = await this.handleAdminReleaseTrialPlan({ userId: this.user._id })

      let message = ''
      let variant = ''

      if(response.message){
        message = this.messages[response.message] || 'Plano gratuito ativado com sucesso'
        variant = 'success'
      } if(response.errors){
        message = this.messages[response.errors] || 'Erro ao ativar plano gratuito'
        variant = 'danger'
      }

      this.$bvModal.hide('modalConfirmReleaseTrial')
      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      })

      await this.reloadUserData()
    },

    async handleReleaseCopyPlan(plan){
      try {
        this.addedCopyPlan = true;
        const response = await this.handleAdminReleaseCopyPlan({
          userId: this.user._id,
          dueDate: new Date(plan.dueDate),
          plan: plan.plan,
          price: plan.price,
          userReleasedPlan: this.currentUser.id,
        })

        let message = ''
        let variant = ''

        if(response.message){
          message = this.messages[response.message] || 'Plano ativado com sucesso'
          variant = 'success'
        } if(response.errors){
          message = this.messages[response.errors] || 'Erro ao ativar plano gratuito'
          variant = 'danger'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000,
        })

        this.openModal = false
        await this.reloadUserData()
      } catch (e) {

      } finally {
        this.addedCopyPlan = false;
      }
    },

    showModalBlockUser(data){
      this.dialogBlock = { ...data }
      this.$bvModal.show('modalConfirmBlockUser')
    },

    async handleBlockAndUnblockUser() {
      let response;
      let message = '';
      let variant = 'success';

      if(this.dialogBlock.block) {
        response = await this.handleUnblockUser(this.dialogBlock._id);
      } else {
        response = await this.handleBlockUser(this.dialogBlock._id);
      }

      if(response.errors) {
        message = this.messages[response.errors];
        variant = 'danger';
      } else if(response.message) {
        message = this.messages[response.message];
      }

      await this.reloadUserData()

      this.$bvModal.hide('modalConfirmBlockUser')
      this.dialogBlock = {
        open: false,
        email: '',
        block: false,
        _id: '',
      };

      this.$bvToast.toast(message, {
        title: 'HOFácil WEB',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      })
    },

    async closeModalChangePhone() {
      this.$refs.changePhone.hide()
      this.$bvToast.toast(`Telefone do usuário ${this.confirmationEmail} atualizado com sucesso!`, {
        title: 'Atenção',
        variant: 'success',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      });
      await this.reloadUserData()
    },

    async closeModalCpfUpdate() {
      setTimeout(() =>{
        this.$refs.modalChangeCPF.hide()
      }, 2000)
      await this.reloadUserData()
    },

    setDataChangePhone(user){
      this.phone = user.profile.phone;
      this.confirmationEmail = user.username;
      this.$refs.changePhone.show();
    },

    async setDataChangeCPF(user){
      this.userIdcpfUpdate = user._id
      const [userFind, userProfileFind] = await Promise.all([
        await this.handleUserById(user._id), await this.handleUserProfileById(user._id)
      ])

      const {user: userResponse } = userFind
      const {userProfile: userProfileResponse } = userProfileFind

      if(
        (userResponse && userResponse.profile && userResponse.profile.cpf && userResponse.profile.cpf.length > 0) ||
        (userProfileResponse && userProfileResponse.cpf && userProfileResponse.cpf.length > 0)
      ) {
        this.cpfUpdate = userProfileResponse && userProfileResponse.cpf && userProfileResponse.cpf.length > 0 ? userProfileResponse.cpf : userResponse.profile.cpf;
        this.$refs.modalChangeCPF.show();
        return
      }
      this.$bvToast.toast('O usuário ainda não cadastrou CPF.', {
        title: 'Atenção',
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000,
      })
    },

    setDeleteAccountd(user){
      this.modalDeleteAccount = {
        open: true,
        user: {
          _id: user._id || '',
          name: user.name || '',
          username: user.username || ''
        }
      }
      this.$bvModal.show('modalConfirmDeleteAccount')
    },

    closeModalSelectDateExemptionAuthentication(){
      this.$refs.selectDateExemptionAuthentication.hide()
    },

    closeModalSetSelectExtraAccessDate(){
      this.$refs.selectExtraAccessDate.hide()
    },

    setSelectDateExemptionAuthentication(user){
      this.twoFactorAuthenticationReleaseDeadlineUserId = user.id
      this.twoFactorAuthenticationReleaseDeadline = null
      this.$refs.selectDateExemptionAuthentication.show()
    },

    setSelectExtraAccessDate(user){
      const {endDateExtraAccessTime} = user
      this.quantityDaysExtraAccess = 0
      this.planId = null
      if (endDateExtraAccessTime) {
        this.quantityDaysExtraAccess =  this.$refs.sectionProfile.formatQuantityDaysExtraAccess(endDateExtraAccessTime)
      }

      if (user.plan && user.plan._id && user.plan.status && user.plan.status === 'paid') {
        this.planId = user.plan._id
      }
      this.quantityDaysExtraAccessUserId = user.id
      this.$refs.selectExtraAccessDate.show()
    },

    clear() {
      if (this.$refs.userBaseAutocomplete.inputValue === '') {
        this.userSelect = undefined
        this.disabled = true
      }
    },

    async selectByUser($event) {
      this.userToReceive = $event
      this.userIdToReceive = this.userToReceive._id
    },

    showTransferFilesBetweenUsers(){
      this.descriptionTransferFiles = `Deseja transferir realmente os arquivos/informações entre os usuários? <br/> Esta ação é irreversível.`
      this.titleTransferFiles = `Transferir os arquivos entre usuários`
      this.$bvModal.show('transferFiles')
    },

    async transferFilesBetweenUsers() {
      try {
        this.loading = true;
        const { data, status, errors } = await this.handleTransferFilesBetweenUsers(
          {
            userIdTransfer: this.userIdTransfer,
            userIdToReceive: this.userIdToReceive,
          }
        )
        this.loading = false;
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('transferFiles')
        this.closeModalTransferFilesBetweenUsers()
        await this.reloadUserData()
      } catch (e) {

      }
    },

    closeModalTransferFilesBetweenUsers(){
      this.$refs.transferFilesBetweenUsers.hide()
    },

    showModalTransferFilesBetweenUsers(user){
      this.userToReceive = null
      this.userIdToReceive = null
      this.userIdTransfer = user.id
      this.$refs.transferFilesBetweenUsers.show()
    },

    showModalChangeUserProfile(user){
      this.userProfile = null
      this.userProfile = user
      console.log(this.userProfile)
      this.$refs.changeUserProfile.show()
    },

    closeModalChangeUserProfile(){
      this.$refs.changeUserProfile.hide()
    },

    async changeUserProfile() {
      try {
        this.loading = true;
        const { data, status, errors } = await this.handleChangeProfile(
          {
            userId: this.userProfile._id,
            role: this.userProfile.role,
          }
        )
        this.loading = false;
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.closeModalChangeUserProfile()
        await this.reloadUserData()
      } catch (e) {

      }
    },

    async saveQuantityDaysExtraAccess() {
      this.loading = true;
      const { data, status, errors } = await this.handleSetQuantityDaysExtraAccess(
        {
          userId: this.quantityDaysExtraAccessUserId,
          quantityDaysExtraAccess: this.quantityDaysExtraAccess,
          planId: this.planId
        }
      )
      this.loading = false;
      let message = errors
      let variant = 'danger'

      if (status === 200 || status === 201) {
        message = data.message
        variant = 'success'
      }

      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
      this.closeModalSetSelectExtraAccessDate()
      await this.reloadUserData()
    },

    async saveDateExemptionAuthentication() {
      this.loading = true;
      const { data, status, errors } = await this.handTwoFactorAuthenticationReleaseDeadline(
        {
          userId: this.twoFactorAuthenticationReleaseDeadlineUserId,
          twoFactorAuthenticationReleaseDeadline: this.twoFactorAuthenticationReleaseDeadline
        }
      )
      this.loading = false;
      let message = errors
      let variant = 'danger'

      if (status === 200 || status === 201) {
        message = data.message
        variant = 'success'
      }

      this.$bvToast.toast(message, {
        title: 'Atenção',
        variant: variant,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
      this.closeModalSelectDateExemptionAuthentication()
      await this.reloadUserData()
    },

    async deleteAccount(){
      try {
        this.loading = true
        const { message, errors } = await this.handleDeleteAccount(this.modalDeleteAccount.user._id)
        let variant = 'success'
        if(errors){
          variant = 'danger'
        }
        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000,
        })
        this.$bvModal.hide('modalConfirmDeleteAccount')
        this.modalDeleteAccount.open =  false
        this.loading = false
        setTimeout(async () => {
          await this.$router.push({ path: '/Usuarios' })
        }, 2000)
      } catch (e) {

      }
    },
  },
  watch: {
    userSelect: _.debounce(async function (newQuery) {
      if (!newQuery || newQuery.length < 3) return
      this.loading = true
      const users = (await this.$api.get(`admin/users/userByUserName/${newQuery}`)).data
      this.users = users
      if(!users || users.length <= 0) {
        this.$bvToast.toast(`Usuário com email: '${newQuery}' não está cadastrado na base de dados!`, {
          title: 'Atenção',
          variant: 'danger',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000,
        })
      }
      this.loading = false
    }, 1500),
  },
}
</script>

<style lang="scss" scoped>
.view-user-details-overlay{
  min-height: 200px;
}
.view-user-details{
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.modal_font_size{
  width: 100%;
  font-family: 'Montserrat',serif;
}
.btn_save {
  border: none;
  background-color: #CBD63E;
  color: #022245;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  line-height: 24px;
  padding: 7px 0;
  width: 98%;
  margin-left: 2%;
  i {
    color: #022245;
    margin-right: 6px;
  }

  img {
    width: 15px;
    height: 15px;
    margin-right: 6px;
  }
}
</style>
